import { RedoOutlined } from '@ant-design/icons';
import propType from 'prop-types';
import React from 'react';

const SubscriptionResult = ({ isSuccess, message, reset }) => (
  <div className="subscription-result">
    <p
      className={`subscription-result__text--${isSuccess ? 'success' : 'fail'}`}
    >
      {isSuccess ? message : message.split('. ')[0]}{' '}
      <p onClick={reset} className="reset">
        {isSuccess ? (
          'Add another email.'
        ) : (
          <>
            <RedoOutlined /> Retry
          </>
        )}
      </p>
    </p>
  </div>
);

SubscriptionResult.propTypes = {
  isSuccess: propType.bool.isRequired,
  message: propType.string.isRequired,
  reset: propType.func.isRequired
};

export default SubscriptionResult;
